import React, { useState } from "react";
import styled from "styled-components";
import Icon from "@material-ui/core/Icon";

const MIN_BLADE_WIDTH = 2;

//Limitation: content titles can only be one word or must have a _,
//need to find fix for this

export const Blades = ({ content = [] }) => {
  const [widths, setWidths] = useState(
    content.map((i, index) => {
      if (!index) {
        return 85;
      }
      return MIN_BLADE_WIDTH;
    })
  );

  const handleBladeChange = (index) => {
    setWidths(
      widths.map((i, idx) => {
        if (index === idx) {
          return 85;
        }
        return MIN_BLADE_WIDTH;
      })
    );
  };

  return (
    <Container>
      {content.map(({ component, title }, index) => (
        <BladeButtonWrapper index={index} widths={widths} key={index}>
          {widths[index] === MIN_BLADE_WIDTH ? (
            <TitleWrapper onClick={() => handleBladeChange(index)}>
              <Icon color="primary">add_circle</Icon>
              <b>{title}</b>
            </TitleWrapper>
          ) : null}
          <ItemWrapper shouldDisplay={widths[index] === MIN_BLADE_WIDTH}>
            {component}
          </ItemWrapper>
        </BladeButtonWrapper>
      ))}
    </Container>
  );
};
/**
 * If the blade is not the one that is currently at 100% we want to hide the content inside
 * doing it this way rather than using a hiddenOn or a ternary allows us to not unload the
 * component and thus keep any internal state it might have. (Looking at you JSON editor!)
 */
export const ItemWrapper = styled.div`
  display: ${({ shouldDisplay }) => (shouldDisplay ? "none" : "flex")};
  flex-grow: 1;
  height: 100%;
  overflow: auto;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  transform: rotate(90deg);
  transform-origin: top right;
  padding-left: 100%;
  > span {
    padding-right: 5px;
  }
`;

export const BladeButtonWrapper = styled.div`
  width: ${({ widths, index }) => widths[index]}%;
  border: 2px solid #3f51b5;
  transition: width 0.7s;
  border-radius: 5px;
  margin-left: 2px;
  margin-right: 2px;
  padding: 5px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 85%;
  justify-content: center;
`;

export default Blades;
